// collectionTransfer.service.ts
import { Injectable } from '@angular/core';
import { CollectionSummaryDTO } from '../models/collectionSummaryDTO.model';

@Injectable({ providedIn: 'root' })
export class CollectionTransferService {
  private summary?: CollectionSummaryDTO;

  setSummary(summary: CollectionSummaryDTO) {
    this.summary = summary;
  }

  getSummary(): CollectionSummaryDTO | undefined {
    return this.summary;
  }

  clear() {
    this.summary = undefined;
  }
}
